// src/components/tour/tourStyles.ts

export const getTourStyles = (isMobile: boolean) => {
  const isDark = document.documentElement.classList.contains('dark');

  return {
    options: {
      zIndex: 10000,
      arrowColor: isDark ? '#1c1c1e' : '#ffffff',
      backgroundColor: isDark ? '#1c1c1e' : '#ffffff',
      overlayColor: isDark ? 'rgba(0,0,0,0.85)' : 'rgba(0,0,0,0.5)',
      primaryColor: '#103254',
      textColor: isDark ? '#e5e7eb' : '#111827',
      width: isMobile ? '90vw' : 380,
    },
    spotlight: {
      borderRadius: 8,
      boxShadow: isDark
        ? '0 0 0 3px #3b82f6, 0 0 20px 4px rgba(59,130,246,0.6)'
        : '0 0 0 2px #103254',
    },
    tooltip: {
      borderRadius: 12,
      padding: isMobile ? 16 : 20,
      paddingRight: isMobile ? 28 : 34,
      fontSize: isMobile ? 13 : 14,
      border: isDark ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.08)',
      boxShadow: isDark
        ? '0 8px 24px rgba(0,0,0,0.5)'
        : '0 8px 24px rgba(16,50,84,0.15)',
    },
    tooltipTitle: {
      fontSize: isMobile ? 15 : 16,
      fontWeight: 600,
    },
    tooltipContent: {
      padding: isMobile ? '8px 0' : '10px 0',
    },
    tooltipFooter: {
      marginTop: isMobile ? 12 : 16,
    },
    buttonNext: {
      backgroundColor: '#103254',
      borderRadius: 8,
      padding: isMobile ? '8px 14px' : '10px 16px',
      fontSize: isMobile ? 13 : 14,
    },
    buttonBack: {
      color: isDark ? '#9ca3af' : '#6b7280',
      fontSize: isMobile ? 13 : 14,
      marginRight: 8,
    },
    buttonSkip: {
      color: isDark ? '#9ca3af' : '#6b7280',
      fontSize: isMobile ? 13 : 14,
    },
    buttonClose: {
      color: isDark ? '#9ca3af' : '#6b7280',
      padding: 8,
      marginBottom: 8,
    },
  };
};